'use client'

import React from 'react'

import { openSupportChat } from '@/legacy-src/components/support/utilities'
import { Button, type ButtonProps } from '@/legacy-src/components/ui/button'

type Props = { children: React.ReactNode } & ButtonProps

// this is a very generic button that opens the chat
// it should be modified through props and not through the component itself
const SupportChatOpenButton: React.FC<Props> = ({ children, ...props }) => {
  return (
    <Button onClick={openSupportChat} {...props}>
      {children}
    </Button>
  )
}

export default SupportChatOpenButton
